export default __webpack_public_path__ + "static/media/WiCSBgMobile.ec85549e.png";